// @flow

import $ from 'jquery'

import { updateCards } from './cards'
import { updateTypeText } from './types'

export const selectGrade = ($button: JQuery) => {
  if ($button.hasClass('active')) {
    return
  }

  $('[data-button="select-grade"]').removeClass('active')
  $button.addClass('active')

  updateCards()
}

export const selectType = ($button: JQuery) => {
  if ($button.hasClass('active')) {
    return
  }

  $('[data-button="select-type"]').removeClass('active')
  $button.addClass('active')

  updateTypeText($button)
  updateCards()
}
